import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AllTicketsHeader from './AllTicketsHeader';
import { dataUsers, delteUser } from 'data/apiConection.js/dataUsers';
import { columnsUsers } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';

const TableViewUsers = () => {
  const [users, setUsers] = useState([]);
  const [ flagDeleteUser , setFlagDeleteUser] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const us = await dataUsers();
        setUsers(us);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [flagDeleteUser]);
  const onDelete = async (user_id) => {
    try {
      const response = await delteUser(user_id);
      setFlagDeleteUser(!flagDeleteUser);
      return response;
    } catch (error) {
      console.error("Error deleting user by id!")
    }
  }
  const columns = columnsUsers(onDelete);
  return (
    <Row className="gx-0 mx-0" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {users && (
        <Col xxl={12} xl={12} style={{ height: '100%' }}>
          <AdvanceTableWrapper
            columns={columns}
            data={users}
            selection
            selectionColumnWidth={52}
            sortable
            pagination
            perPage={80}
            rowCount={users.length}
          >
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Card.Header className="border-bottom border-200 px-0">
                <AllTicketsHeader title="Users" table layout="table-view" />
              </Card.Header>
              <Card.Body className="p-0" style={{ flexGrow: 1, overflowY: 'auto' }}>
                <AdvanceTable
                  table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs--1 mb-0 w-100 h-100',
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTablePagination table />
              </Card.Footer>
            </Card>
          </AdvanceTableWrapper>
        </Col>
      )}
    </Row>
  );
};

export default TableViewUsers;
